//@flow
import * as React from 'react';
import {connect} from "react-redux";
import SearchInput
  from "../../../../../components/composed/SearchPage/SearchBox/ConnectedSearchInput/SearchInput/SearchInput";
import text from "../../../../../services/localization/text";
import type {inputIsFocused, spinnerIsShown} from "../../../../../services/flowTypes/appFlowTypes";
import type {
  organizationName
} from "../../../../../services/flowTypes/dataFlowTypes";
import {handleSearchIcoClick, onUpdateOrganizationsSearchProp} from "../../../../../services/flowTypes/propFnFlowTypes";
import organizationsSearchActions
  from "../../../../../store/organizations/organizationsSearch/organizationsSearchActions";

type Props = {
  name: organizationName,
  onUpdateOrganizationsSearchProp: onUpdateOrganizationsSearchProp,
  handleSearchIcoClick: handleSearchIcoClick,
  spinnerIsShown: spinnerIsShown
};
type State = {
  inputIsFocused: inputIsFocused
};
class ConnectedOrganizationsSearchInput extends React.Component <Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      inputIsFocused: true
    };
  }
  onBlur = () => {this.setState({inputIsFocused: false})};
  onFocus = () => {this.setState({inputIsFocused: true})};
  onChange = (e:SyntheticEvent<HTMLInputElement>) => {
    const organizationsSearchObj = {
      offset: 0,
      name: e.target.value
    };
    this.props.onUpdateOrganizationsSearchProp(organizationsSearchObj);
  };
  render() {
    return (
      <SearchInput
        spinnerIsShown={this.props.spinnerIsShown}
        inputIsFocused={this.state.inputIsFocused}
        handleSearchIcoClick={this.props.handleSearchIcoClick}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        onChange={this.onChange}
        text={this.props.name}
        placeholder={text.organizationsSearchPlaceholder}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    name: state.organizations.search.name
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onUpdateOrganizationsSearchProp: (organizationsSearchObj) => dispatch({type: organizationsSearchActions.ORG_SEARCH_PROP_UPDATE,
      value: organizationsSearchObj})
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConnectedOrganizationsSearchInput);